import Tippy from "@tippyjs/react";
import React, { useEffect, useState } from "react";

function CurrencyField({
  label,
  value = "",
  transparent = true,
  className = "",
  focusOnStart = false,
  overrideFocus = false,
  disabled = true,
  onChangeFloat = (value) => {},
}) {
  const [inputValue, setInputValue] = useState((value || 0).toString());
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (overrideFocus !== false) {
      setInputValue(overrideFocus);
    }
  }, [overrideFocus]);

  // Format the value as "100,00 €" when not focused
  const formatValue = (value) => {
    const number = parseFloat(value);
    return isNaN(number) ? "" : number.toFixed(2).replace(".", ",") + " €";
  };

  // Parse the formatted value back to a float
  const parseValue = (formattedValue) => {
    const numberString = formattedValue.replace(" €", "").replace(",", ".");
    return parseFloat(numberString);
  };

  const handleFocus = () => {
    setIsFocused(true);
    // When focused, show the raw number without formatting
    setInputValue(parseValue(inputValue).toString());
  };

  const handleBlur = () => {
    setIsFocused(false);
    // When blurred, format the value as currency
    setInputValue(formatValue(inputValue));
  };

  const handleChange = (e) => {
    if (disabled) return;

    const newValue = e.target.value;
    setInputValue(newValue);

    const floatValue = parseValue(newValue);
    if (!isNaN(floatValue)) {
      onChangeFloat(floatValue);
    }
  };

  useEffect(() => {
    setInputValue(
      value && isFocused ? value.toString() : formatValue(value || "")
    );
  }, [value, isFocused]);

  return (
    <div className={`w-full ${className}`}>
      <Tippy
        content={label}
        delay={500}
        className="custom-tooltip"
        disabled={!label}
      >
        <input
          disabled={disabled}
          type="text"
          placeholder={label}
          value={inputValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={`
            w-full
            h-8
            px-2
            py-1
            rounded-xl
            border
            border-gray-300
            focus:border-2 focus:border-blue-300
            outline-none
            transition
            ease-in-out
            duration-150
            ${disabled ? "bg-neutral-100 text-shadow_25" : transparent ? "bg-transparent" : "bg-white"}      
          `}
          style={{
            fontSize: "14px",
          }}
        />
      </Tippy>
    </div>
  );
}

export default CurrencyField;
